document.addEventListener("DOMContentLoaded", function () {
  var product = document.querySelector(".custom_product__container");
  var shopbar = document.querySelector(".shopbar");

  window.onscroll = function () {
    var productRect = product.getBoundingClientRect();
    const cartFloatingBubble = document.querySelector('.cart-floating-bubble');
    if (productRect.bottom < 200) {
      if(cartFloatingBubble) {
        cartFloatingBubble.style.bottom = '130px';
      }
      shopbar.classList.add("shopbar-active");
    } else {
      if(cartFloatingBubble) {
        cartFloatingBubble.style.bottom = '60px';
      }
      shopbar.classList.remove("shopbar-active");
    }

    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
      shopbar.classList.remove("shopbar-active");
    }
  };

  function addProductToCart() {
    const addButton = document.querySelector(".product-form__submit");
    const btnShopBar = document.querySelector(".btn-shop-bar");
    const btnShopBarPrime = document.querySelector(".btn-shop-bar-prime");
    btnShopBar.addEventListener("click", function () {
      addButton.click();
    });

    btnShopBarPrime.addEventListener("click", function () {
      addButton.click();
    });
  }

  addProductToCart();
});

function changeToSubscription() {
  if (typeof window.caffeineRunPrimeFromCard === "function") {
    const primeBtn = document.querySelector("[data-payment-cta=\"prime\"]");
    window.caffeineRunPrimeFromCard(primeBtn ? primeBtn.id : null);
  } else if (typeof window.setPaymentMethodSelection === "function") {
    window.setPaymentMethodSelection("prime");
  }
}

function updateProductFixedBar(productInfo) {
  const shopbar = document.querySelector(".shopbar");
  if (!shopbar) return;

  window.shopbarCurrentProduct = productInfo;

  const isRtd = (productInfo.handle || "").indexOf("rtd") !== -1;
  const price = parseFloat(productInfo.price) * (isRtd ? 3 : 1);
  const flatDiscountCents = productInfo.flat_discount ? parseFloat(productInfo.flat_discount) * 100 : 0;
  const discountedPriceMoney = flatDiscountCents > 0 ? price - flatDiscountCents : null;
  const pixDiscountPercentage = parseFloat(shopbar.dataset.pixDiscountPercentage || 0);

  const title = document.getElementById("shopbarProductTitle");
  if (title) {
    title.innerHTML = (productInfo.title || "")
      .toUpperCase()
      .replace(/TO GO/g, "")
      .replace(/380G/g, "")
      .replace(/220G/g, "")
      .replace(/PRONTO PARA BEBER/g, "");
  }

  const image = document.getElementById("shopbar-variant-image");
  if (image && productInfo.image) image.src = productInfo.image;

  const variantName = document.getElementById("shopbarVariantName");
  if (variantName) variantName.innerHTML = productInfo.size_friendly || "";

  const isPrimeExclusive = productInfo.is_prime_exclusive === "true";

  const exclusiveInfo = document.getElementById("shopbarExclusivePrimeInfo");
  if (exclusiveInfo) {
    exclusiveInfo.style.display = isPrimeExclusive ? "" : "none";
  }

  const defaultPriceInfo = document.getElementById("shopbarDefaultPriceInfo");
  if (defaultPriceInfo) {
    defaultPriceInfo.style.display = isPrimeExclusive ? "none" : "";
  }

  const shopbarDivide = document.getElementById("shopbarDivide");
  if (shopbarDivide) {
    shopbarDivide.style.display = isPrimeExclusive && defaultPriceInfo ? "none" : "";
  }

  const defaultPrice = document.getElementById("shopbarDefaultPrice");
  if (defaultPrice) {
    defaultPrice.innerHTML = formatCurrency(price);
    defaultPrice.classList.toggle("shopbar-old-price", !!discountedPriceMoney);
  }

  const pixWrapper = document.getElementById("shopbarPixWrapper");
  const pixPrice = document.getElementById("shopbarPixPrice");
  if (pixWrapper) {
    const showPix = pixDiscountPercentage > 0;
    pixWrapper.style.display = showPix ? "" : "none";
    if (showPix && pixPrice) {
      const discountValuePix = price * (pixDiscountPercentage / 100);
      const priceAfterDiscount = discountedPriceMoney !== null ? discountedPriceMoney : price;
      pixPrice.innerHTML = formatCurrency(priceAfterDiscount - discountValuePix);
    }
  }

  const newPrice = document.getElementById("shopbarNewPrice");
  if (newPrice) {
    const showNewPrice = pixDiscountPercentage <= 0 && discountedPriceMoney !== null;
    newPrice.style.display = showNewPrice ? "" : "none";
    if (showNewPrice) newPrice.innerHTML = formatCurrency(discountedPriceMoney);
  }

  const defaultDiscountText = document.getElementById("shopbarDefaultDiscountText");
  if (defaultDiscountText) {
    const show = pixDiscountPercentage > 0 && discountedPriceMoney !== null;
    defaultDiscountText.style.display = show ? "" : "none";
    if (show) defaultDiscountText.innerHTML = formatCurrency(discountedPriceMoney);
  }

  const defaultInstallment = document.getElementById("shopbarDefaultInstallment");
  if (defaultInstallment) {
    const installmentSpan = defaultInstallment.querySelector("#installment-price-divide");
    const minInstallment = parseFloat(shopbar.dataset.minInstallmentValue || 1);
    const maxInstallment = parseFloat(shopbar.dataset.maxInstallmentValue || 1);
    const numberOfInstallments = Math.max(
      1,
      Math.min(
        Math.floor(price / (minInstallment * 100)),
        maxInstallment
      )
    );
    if (installmentSpan) installmentSpan.innerHTML = formatCurrency(price / numberOfInstallments);
  }

  const primeTag = document.getElementById("shopbarPrimeTag");
  const primePrice = document.getElementById("shopbarPrimePrice");
  if (primeTag || primePrice) {
    const primeDiscount = productInfo.prime_discount
      ? parseFloat(productInfo.prime_discount)
      : parseFloat(shopbar.dataset.primeDiscountDefault || 0);
    const priceDiff = price * (primeDiscount / 100);
    if (primeTag) primeTag.innerHTML = `${Math.floor(primeDiscount)}% OFF`;
    if (primePrice) primePrice.innerHTML = formatCurrency(price - priceDiff);
  }

  const soldOut = !!productInfo.sold_out;
  const btnShopBar = document.getElementById("btnShopBar");
  if (btnShopBar) {
    btnShopBar.disabled = soldOut;
    btnShopBar.classList.toggle("btn-shop-bar-sold-out", soldOut);
    btnShopBar.textContent = soldOut ? "Esgotado" : (shopbar.dataset.buttonTextDefault || "Adicionar ao carrinho");
  }

  const btnShopBarPrime = document.getElementById("btnShopBarPrime");
  if (btnShopBarPrime) {
    btnShopBarPrime.disabled = soldOut;
    btnShopBarPrime.classList.toggle("btn-shop-bar-sold-out", soldOut);
    btnShopBarPrime.textContent = soldOut ? "Esgotado" : (shopbar.dataset.buttonTextPrime || "Assine e economize");
  }
}

if (typeof window !== "undefined") {
  window.updateProductFixedBar = updateProductFixedBar;
}
